export default __webpack_public_path__ + "static/media/ic_info.9f9585f4.svg";